<template>
  <div
    id="app"
    :class="{'pc': !$ua.isMobile, 'mobile': $ua.isMobile}"
  >
    <a-locale-provider :locale="locale">
      <div style="min-height:100%; height: 100%">
        <router-view v-if="isRouterAlive" />
        <mix-account />
      </div>
    </a-locale-provider>
    <merge-tip-dialog
      v-if="isNoticeBind && !$ua.isMobile"
      ref="mergeTipDialog"
      :value="$store.state.baseinfo.truename"
      :visible="isNoticeBind"
    />
    <template v-if="isNoticeBind && $ua.isMobile">
      <merge-m-tip-dialog
        :value="$store.state.baseinfo.truename"
        :visible="isNoticeBind"
      />
    </template>
    <i
      v-if="showHelpStart"
      id="help-start"
      class="iconfont iconicon-test92"
      :style="{right: iconSpace + 'px'}"
      @click.stop="showHelp = true"
    />
    <template>
      <ifream-dialog :show.sync="showHelp" />
    </template>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import MixAccount from '@/components/pc/mix-account'
import MergeTipDialog from '@/components/pc/merge/MergeTipDialog'
import IfreamDialog from '@/components/pc/merge/HelpIfream'
import MergeMTipDialog from '@/components/mobile/merge/BindDialog'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import enUS from 'ant-design-vue/lib/locale-provider/en_US'
import { helpConfig } from '@/lib/help'
import { getSocketToken } from '@/services'
import { getLang } from '@/lib/storage'
let socket
let interval = null
let hasPang = true
export default {
  components: {
    MixAccount,
    MergeTipDialog,
    MergeMTipDialog,
    IfreamDialog
  },
  data () {
    return {
      locale: this.getLang() === 'en' ? enUS : zhCN,
      isRouterAlive: true,
      showHelp: false,
      iconSpace: 80
    }
  },
  computed: {
    ...mapState(['auth', 'realbackAuth']),

    isNoticeBind () {
      if (this.$store.state.baseinfo.is_notice_bind) {
        return this.$store.state.baseinfo.is_notice_bind === 1
      }
      return false
    },
    showHelpStart () {
      const { name } = this.$route
      if (helpConfig[name]) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    auth: {
      async handler (token) {
        this.setSocket(token)
        if (!this.realbackAuth && token) {
          this.exchangeAuth()
        }
      },
      immediate: true
    }
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  mounted () {
    this.setHelpStartSpace()
  },
  methods: {
    ...mapActions(['setSocketMessage', 'exchangeAuth']),
    getLang,
    async setSocket (token) {
      if (token) {
        const chain = await getSocketToken()
        chain.onSuccess(payload => {
          if (payload.token) {
            this.linkSocket(payload.token)
          }
        })
          .config({
            warn: false
          }).fetch()
      } else {
        if (socket) {
          clearInterval(interval)
          socket.close()
        }
      }
    },
    linkSocket (token) {
      if (!WebSocket) {
        return
      }
      const appname = window.location.protocol === 'http:' ? 'westartrack_dev' : 'westartrack_prod'
      if (socket) {
        socket.close()
      }
      socket = new WebSocket('wss://wss.westartrack.com/notice')
      socket.onopen = () => {
        socket.send(JSON.stringify({
          type: 'auth',
          token,
          appname
        }))
      }
      socket.onmessage = data => {
        try {
          const info = JSON.parse(data.data)
          if (info.type === 'message' && !info.error && info.content) {
            this.setSocketMessage(info.content)
          } else if (info.type === 'ping') {
            hasPang = true
          }
        } catch (err) { }
      }
      clearInterval(interval)
      interval = setInterval(() => {
        hasPang = false
        socket.send(JSON.stringify({
          type: 'ping'
        }))
        setTimeout(() => {
          if (!hasPang) {
            clearInterval(interval)
            socket.close()
            this.linkSocket(token)
          }
        }, 20000)
      }, 30000)
    },
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },
    setHelpStartSpace () {
      let helpSpace = (window.innerWidth - 1280) / 4
      this.iconSpace = helpSpace <= 60 ? 30 : helpSpace
    }
  }
}
</script>

<style lang="scss">
@import './assets/css/common.scss';
/* @import './assets/font-m/iconfont.css';
@import './assets/font-pc/iconfont.css'; */

#app {
  margin: auto;
  &.pc {
    // max-width: 1200px;
    background-color: #f7f7f7;
    #help-start {
      position: fixed;
      bottom: 50px;
      z-index: 999;
      font-size: 40px;
      color: #608bc3;
      background-color: #fff;
      box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.17);
      border-radius: 50%;
    }
    #help-start:hover {
      cursor: pointer;
    }
  }
  &.mobile {
    position: relative;
    width: 100%;
    overflow-x: hidden;
    background-color: #f3f3f3;
    height: 100%;
    #help-start {
      display: none;
    }
  }
}
</style>
